module.exports = __webpack_public_path__ + "img/what-is-an-api-thumbnail-arrow.92a705f7.jpg";